import { lazy } from 'react'

/**
 * Módulo: Portal (vista Seller / Cliente)
 * Páginas que ve el cliente/seller dentro del Layout unificado.
 * Incluye: mi empresa, mi equipo, accionables, reportes.
 * Mensajes se comparte con el módulo comunicaciones (el rol cliente tiene su permiso-módulo).
 */
export default {
  id: 'portal',
  nombre: 'Mi Portal',
  descripcion: 'Vista del seller: empresa, equipo, accionables, reportes',
  icono: 'home',
  tipo: 'core',
  version: '1.0.0',
  // Solo visible para clientes (sellers) — admin/consultor tienen sus módulos propios

  routes: [
    { path: 'mi-empresa', component: lazy(() => import('./pages/MiEmpresaPage')) },
    { path: 'mi-equipo', component: lazy(() => import('./pages/MiEquipoPage')) },
    { path: 'mis-accionables', component: lazy(() => import('./pages/MisAccionablesPage')) },
    // Un solo visor de cliente (comité del 21-oct, B): la misma página que
    // /portal/reportes, con su gate de plan y permiso.
    { path: 'mis-reportes', component: lazy(() => import('@portal/pages/PortalReportesPage')) },
    { path: 'mi-diagnostico', component: lazy(() => import('./pages/MiDiagnosticoPage')) },
  ],

  menuItems: [
    { label: 'Mi empresa', path: '/mi-empresa', icon: 'building' },
    { label: 'Mi equipo', path: '/mi-equipo', icon: 'users' },
    { label: 'Accionables', path: '/mis-accionables', icon: 'check-square' },
    { label: 'Reportes', path: '/mis-reportes', icon: 'bar-chart-2' },
    { label: 'Diagnóstico', path: '/mi-diagnostico', icon: 'target' },
  ],

  features: [
    'mi-empresa',
    'mi-equipo',
    'mis-accionables',
    'mis-reportes',
    'mi-diagnostico',
  ],

  // soloCliente (#58): el portal es el wrapper del cliente/seller. No se gatea
  // por rol sino por tipo de usuario — se muestra solo si userDoc.tipo==='cliente'.
  soloCliente: true,
  permisoModulos: [],

}
